/* eslint-disable react-hooks/rules-of-hooks */
import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { BiSearchAlt } from '@react-icons/all-files/bi/BiSearchAlt';
import useTranslate from '~hooks/useTranslate/useTranslate';
import { toggleScroll } from '~helpers/scroll';

import styles from './search.module.scss';

const SearchForm = ({
  className,
  searchIcon,
  iconWidth = 24,
  iconHeight = 24,
  marketPrefix = '/',
  isDisabled,
}) => {
  const [localSearch, setLocalSearch] = useState(false);
  const [searchBoxQuery,] = useState();
  const searchInputRef = useRef();
  const searchFormRef = useRef();

  const handleOnSearchIconClick = () => {
    setLocalSearch(!localSearch);
    toggleScroll('search');
  };

  const handleOverlayClickClose = (event) => {
    if (event.target.classList.contains(styles.searchForm)) {
      toggleScroll('search');
      setLocalSearch(false);
    }
  };

  const formSubmitBoxHandler = (e) => {
    e.preventDefault();
    if (searchBoxQuery === '') {
      e.target.querySelector('input').focus();
    } else {
      const searchUrl =
        marketPrefix !== '/'
          ? `/${marketPrefix}/s${process.env.TRAILING_SLASH ? '/' : ''}?s=${e.target.value}`
          : `/s${process.env.TRAILING_SLASH ? '/' : ''}?s=${e.target.value}`;
      window.location = `${window.location.origin}${searchUrl}`;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (localSearch && searchFormRef.current && !searchFormRef.current.contains(event.target)) {
        setLocalSearch(false);
        toggleScroll('search');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [localSearch]);

  useEffect(() => {
    if (localSearch) searchInputRef.current.focus();
  }, [localSearch]);

  return (
    <div className={className || ''} ref={searchFormRef}>
      <button
        type="button"
        aria-label="Search"
        onClick={handleOnSearchIconClick}
        className={`${styles.searchButton || ''} ${
          localSearch && (styles.active || '')
        } search-gtm btn-cta`}
        disabled={isDisabled}
      >
        {searchIcon === null ? (
          <BiSearchAlt title="Search Icon" />
        ) : (
          <img alt="Search Icon" src={searchIcon} width={iconWidth} height={iconHeight} />
        )}
        {styles.close && <span className={styles.close || ''} />}
      </button>
      {localSearch && (
        <div
          onClick={handleOverlayClickClose}
          onKeyDown={handleOverlayClickClose}
          tabIndex={0}
          role="button"
          aria-label="Close search"
          className={`${styles.searchForm || ''} ${styles.show || ''}`}
        >
          <div className={styles.form || ''}>
            <input
              type="text"
              aria-label={useTranslate('search', 'Search...')}
              placeholder={useTranslate('search', 'Search...')}
              className={styles.formInput || ''}
              maxLength="60"
              ref={searchInputRef}
              onKeyUp={(event) => {
                if (event.key === 'Enter') {
                  formSubmitBoxHandler(event);
                }
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

SearchForm.propTypes = {
  className: PropTypes.string.isRequired,
  searchIcon: PropTypes.string,
  iconWidth: PropTypes.number,
  iconHeight: PropTypes.number,
  pageContext: PropTypes.shape({}),
  marketPrefix: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default SearchForm;
